import { createSearchParams } from 'react-router-dom';

import { optionsService } from '@/services/instance/optionsService';

export const getProviderUrl = (provider: 'facebook' | 'google') => {
    const query = createSearchParams({
        ...optionsService.getQueryArgs(),
        r: optionsService.getAppId(),
        cookies: 'true',
    }).toString();

    return `/external/login/${provider}?${query}`;
};
